import { __extends } from "tslib";
import { Backend } from './base';
var WxBackend = /** @class */ (function (_super) {
    __extends(WxBackend, _super);
    function WxBackend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sdk = wx;
        return _this;
    }
    WxBackend.prototype.normalizeEnvInfo = function (systemInfo, networkStatus) {
        return {
            host_platform: 'wx',
            host_app_name: 'Weixin',
            host_app_version: systemInfo.version,
            platform: systemInfo.platform,
            sdk_version: systemInfo.SDKVersion,
            os_name: systemInfo.system.split(' ')[0],
            os_version: systemInfo.system.split(' ')[1],
            device_brand: systemInfo.brand,
            device_model: systemInfo.model,
            screen_width: systemInfo.screenWidth,
            screen_height: systemInfo.screenHeight,
            resolution: systemInfo.screenWidth + 'x' + systemInfo.screenHeight,
            pixel_ratio: systemInfo.pixelRatio,
            network_type: networkStatus.networkType,
        };
    };
    return WxBackend;
}(Backend));
export default WxBackend;
//# sourceMappingURL=wx.js.map